import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
// import { Skeleton } from 'components/Skeleton';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

import { HorizontalBar } from 'react-chartjs-2';
export class BarCharts extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    DashBoardStore: PropTypes.object,
    location: PropTypes.object,
    history: PropTypes.object,
    KeyMetricsProfile: PropTypes.object,
    loading: PropTypes.bool,
    getBarCharts: PropTypes.func
  }

  constructor(props) {
    super(props);
    this.chartReference = React.createRef();
    this.state = {
      isLoading: this.props.loading
    };
  }
  componentDidMount() {
    this.props.getBarCharts({},() => this.setState({isLoading: true}));
  }

  onClickedBarChart = (data) => {
    const number = data.map(x => x._index);
    if (number[0] === 0) {
      this.props.history.push('/work-order-list?Status=1&skip=1&sortField=refNo&sortOrder=descending&take=10&type=value%3D0');
    }
    if (number[0] === 1) {
      this.props.history.push('/work-order-list?ApingStatusType=Overdue&datetime=2020-06-07T11%3A26%3A36-07%3A00&dueStatus=1&skip=1&sortField=refNo&sortOrder=descending&take=10&type=value%3D0');
    }
    if (number[0] === 2) {
      this.props.history.push('/work-order-list?AgingStatusFrom=30&ApingStatusType=Past%20due&skip=1&sortField=refNo&sortOrder=descending&take=10&type=value%3D0');
    }
  }

  renderBarChart = () => {
    const { totalWOOpens, totalWOOverdues, pastDueGreaterOrEqualThan30Days } = this.props.KeyMetricsProfile;
    const information = [].concat(totalWOOpens, totalWOOverdues, pastDueGreaterOrEqualThan30Days);
    const data = {
      labels: ['Total open WOs', 'Total Overdue', 'Past due >= 30 days'],
      datasets: [
        {
          label: 'Total Open WOs',
          backgroundColor: ['#238823', '#FFBF00', '#D2222D'],
          borderColor: ['#238823', '#FFBF00', '#D2222D'],
          borderWidth: 0.5,
          hoverBackgroundColor: ['#238823', '#FFBF00', '#D2222D'],
          hoverBorderColor: ['#238823', '#FFBF00', '#D2222D'],
          data: information
        }
      ]
    };

    return (
      <div className='bar-charts-metrics box-form-siteone clearfix'>
        <Row xs={12} md={12} className='bar-chart-content'>
          <Col md={12} xs={12} className='bar-chart-progress'>
            <HorizontalBar
              ref={this.chartReference}
              data={data}
              height={100}
              width={100}
              options={{
                maintainAspectRatio: false, responsive: true, layout: { padding: { left: 10, right: 10, top: 0, bottom: 0 } }, scales: { xAxes: [{ ticks: { beginAtZero: true, autoSkip: false }, barPercentage: 0.4, barThickness: 16 }] }, legend: { display: false }, tooltips: {
                  callbacks: {
                    label: tooltipItem => `${tooltipItem.yLabel}: ${tooltipItem.xLabel}`,
                    title: () => null
                  }
                }
              }}
              onElementsClick={(elems) => this.onClickedBarChart(elems)} />
          </Col>
        </Row>
      </div>
    );
  }

  renderSkeleton = () => {
    return (
      <SkeletonTheme color='#efe6e6'>
        <Row xs={12} md={12}>
          <Col md={12} xs={12}>
            <Skeleton count={1} style={{ height: 100, margin: '20px 0px 15px 0px'}} />
          </Col>
        </Row>
      </SkeletonTheme>
    );
  }

  render() {
    const {isLoading} = this.state;
    return (
      <React.Fragment>
        {isLoading === false ? this.renderSkeleton() : this.renderBarChart()}
      </React.Fragment>
    );
  }
}

export default BarCharts;



// WEBPACK FOOTER //
// ./src/Dashboard/Components/bar-charts.js